import { snakeStore, SORT_COLUMN, SORT_DIRECTION } from '@app/plugins/vuex-async-pagginate';
import { NumberService } from '@call-tracking/services/NumberService';

export const table = snakeStore({
  state: {
    [SORT_COLUMN]: 'calltracking_activated_at',
    [SORT_DIRECTION]: 'desc'
  },
  actions: {
    getData: (_, params) => NumberService.getList(params)
  }
});
